import { useState, useEffect } from 'react';

/**
 * Hook giúp trì hoãn một giá trị đầu vào trong một khoảng thời gian nhất định
 * @param value Giá trị cần trì hoãn
 * @param delay Thời gian trì hoãn (ms), mặc định là 500ms
 * @returns Giá trị sau khi đã trì hoãn
 */
export function useDebounce<T>(value: T, delay: number = 500): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Tạo timeout để cập nhật giá trị sau khoảng thời gian delay
    const timer = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    // Cleanup function sẽ chạy khi component unmount hoặc dependencies thay đổi
    return () => {
      clearTimeout(timer);
    };
  }, [value, delay]);

  return debouncedValue;
} 